import React, { useState, useEffect } from 'react';
import { useTheme } from '../ThemeContext';
import styles from './Reports.module.css';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CiEdit } from "react-icons/ci";
import dayjs from 'dayjs';
import { RiDeleteBack2Line } from "react-icons/ri";
import { alpha, styled } from '@mui/material/styles';
import { green } from '@mui/material/colors';
import { red } from '@mui/material/colors';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useAuth } from '../auth/AuthContext';
import { getUserPreferences, setUserPreferences } from '../userPreferences';
//------------------------------------------------------------
//const config.ipAddress = '127.0.0.1'; // IP for developement local
//const config.ipAddress = '192.168.1.200'; // IP for deployment IIS
//----

const Reports = () => {
  const { theme } = useTheme();
  const { user } = useAuth();

  const [actionData, setActionData] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const [showCompleted, setShowCompleted] = useState(true); 
  const [showLate, setShowLate] = useState(false); 
  const [filteredActionData, setFilteredActionData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [actionTypeData, setActionTypeData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [togglePreferencesLoadedFor, setTogglePreferencesLoadedFor] = useState('');
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    actionID: '',
    locationID: '',
    locationName: '',
    actionName: '',
    actionType: '',
    actionEmployee: '',
    completedEmployee: '',
    dueDate: null,
    completedDate: null,
    sortOrder: '',
  });
  const [deleteAction, setDeleteAction] = useState({
    ActionID: '',
    ActionName: '',
  });


    //----------------------------ACTION TABLE COLUMNS ---------------------------------------------------------
  
    const columns = [
      { field: 'CompanyAndDivision', headerName: 'Location', width: 350 },
      { field: 'ActionName', headerName: 'Action Name', width: 300 },
      { field: 'ActionTypeName', headerName: 'Action Type', width: 150 },
      { field: 'AssignedEmployeeName', headerName: 'Employee Assigned', width: 200 },
      { field: 'CompletedEmployeeName', headerName: 'Completed By', width: 200 },
      { field: 'DueDate', headerName: 'Due Date', width: 100,
      renderCell: (params) => {
        // Extracting dueDate and completedDate from row data
        const dueDate = params.row.DueDate;
        const completedDate = params.row.CompletedDate;
  
        // Checking if dueDate has passed and completedDate is null
        const isLate = dayjs(dueDate).isBefore(dayjs(), 'day') && completedDate === null;
  
        return (
          <span style={{ color: isLate ? 'red' : 'inherit' }}>
            {dueDate}
          </span>
        );
      },
      },
      { field: 'CompletedDate', headerName: 'Completed Date', width: 150 },
      {
        field: 'Edit',
        headerName: 'Edit',
        sortable: false,
        renderCell: (params) => (
          <CiEdit
            style={{ fontSize: '30px', cursor: 'pointer' }}
            onClick={() => handleEditClick(params.row)}
          />
        ),
        width: 60,
      },
      
    {
      field: 'Link',
      headerName: 'Status',
      sortable: false,
      renderCell: (params) => {
        const isLate = params.row.DueDate && dayjs(params.row.DueDate).isBefore(dayjs(), 'day');
        const isCompleted = params.row.CompletedDate;
  
        if (isCompleted) {
            // If the task is completed, display 'Completed' in green
            return <span style={{ color: 'green' }}>Completed</span>;
        } else if (isLate) {
            // If the task is late but not completed, display the link in red and add 'Late'
            return (
                <>
                    {/* <MdOutlineLibraryAddCheck   
                        style={{ fontSize: '25px', cursor: 'pointer', color: 'red' }} 
                        //onClick={() => handleLinkClick(params.row)} 
                    /> */}
                    <span style={{ color: 'red', marginLeft: '5px' }}>Late</span>
                </>
            );
        } else {
            // If the task is not completed and not late, display the default link
            return (
              <>
                {/* <MdOutlineLibraryAddCheck   
                    style={{ fontSize: '25px', cursor: 'pointer' }} 
                    //onClick={() => handleLinkClick(params.row)} 
                /> */}
                <span style={{ marginLeft: '3px' }}>Pending</span>
                </>
            );
        }
      },
      width: 130,
    },
    {
      field: 'Delete',
      headerName: 'Delete',
      sortable: false,
      renderCell: (params) => (
        <RiDeleteBack2Line
          style={{ fontSize: '25px', cursor: 'pointer', paddingLeft: '10px', color: '#7d2110' }}
          onClick={() => handleDeleteAction(params.row)}
        />
      ),
      width: 90,
    },
    
    ];
    //----------------------END ACTION TABLE COLUMNS ------------------------------------------------------------------------------
//-----------------------------FETCH SQL DATA--------------------------------------------------------------------------------------------------
const fetchData = async () => {
  try {
    //console.log(config.ipAddress);

      const response = await fetch(`/api/`);
      const result = await response.json();

     // 'ActionID' is unique
    const actionDataWithId = result.actionTable.map(item => ({
      ...item,
      DueDate: item.DueDate ? item.DueDate.split('T')[0] : null, // Ensure DueDate is in 'YYYY-MM-DD' format
      CompletedDate: item.CompletedDate ? item.CompletedDate.split('T')[0] : null, // Ensure CompletedDate is in 'YYYY-MM-DD' format
      id: item.ActionID,
    }));

    
      //all the tables
     
      setActionData(actionDataWithId);
      setEmployeeData(result.employeeTable);
      setActionTypeData(result.actionTypeTable);
        
      
  } catch (error) {
      console.error('Error fetching data:', error);
  }
  };



  
  //------------------------------END FETCH SQL DATA-------------------------------------------------------------------------------------------

const handleChangeEditAction = (field, event) => {
  if (event === undefined) {
    console.error('handleChangeEditAction: No value provided for field', field);
    return;
  }

  const newValue = event.target ? event.target.value : event;

  setEditFormData(prevState => ({
    ...prevState,
    [field]: newValue,
  }));
};

const handleEditClick = (rowData) => {
  const actionType = actionTypeData.find(type => type.ActionTypeName === rowData.ActionTypeName);
  const assignedEmployee = employeeData.find(employee => employee.EmployeeName === rowData.AssignedEmployeeName);
  const completedEmployee = employeeData.find(employee => employee.EmployeeName === rowData.CompletedEmployeeName);

  setEditFormData({
    actionID: rowData.ActionID,
    locationID: rowData.LocationID,
    locationName: rowData.CompanyAndDivision || '',
    actionName: rowData.ActionName || '',
    actionType: actionType ? actionType.ActionTypeID : '',
    actionEmployee: assignedEmployee ? assignedEmployee.EmployeeID : '',
    completedEmployee: completedEmployee ? completedEmployee.EmployeeID : '',
    dueDate: rowData.DueDate ? dayjs(rowData.DueDate) : null,
    completedDate: rowData.CompletedDate ? dayjs(rowData.CompletedDate) : null,
    sortOrder: rowData.SortOrder || '',
  });
  setIsEditDialogOpen(true);
};

const handleDeleteAction = (rowData) => {
  setDeleteAction({
    ActionID: rowData.ActionID,
    ActionName: rowData.ActionName || '',
  });
  setIsDeleteDialogOpen(true);
};

const handleEditActionSave = async () => {
  try {
    const response = await fetch(`/api/updateAction/${editFormData.actionID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(editFormData),
    });

    if (!response.ok) throw new Error('Failed to update action');

    setIsEditDialogOpen(false);
    setRefreshData((prev) => !prev);
  } catch (error) {
    console.error('Error updating action:', error);
  }
};

const handleDeleteActionSave = async () => {
  try {
    const response = await fetch(`/api/deleteAction/${deleteAction.ActionID}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(deleteAction),
    });

    if (!response.ok) throw new Error('Failed to delete action');

    setIsDeleteDialogOpen(false);
    setRefreshData((prev) => !prev);
  } catch (error) {
    console.error('Error deleting action:', error);
  }
};



  //------------------------------USE EFFECTS------------------------------------------------------------------------------
  
  //for fetching SQL data
  useEffect(() => {
    fetchData();
    }, [refreshData]);

    useEffect(() => {
      if (!employeeData.length) {
        return;
      }

      const employeeNames = new Set(employeeData.map((employee) => employee.EmployeeName).filter(Boolean));
      const savedEmployee = user?.email
        ? getUserPreferences(user.email).reportsAssignedEmployee || ''
        : '';

      if (savedEmployee && employeeNames.has(savedEmployee)) {
        setSelectedEmployee(savedEmployee);
        return;
      }

      const normalizedEmail = String(user?.email || '').trim().toLowerCase();
      const normalizedName = String(user?.name || '').trim().toLowerCase();
      const matchedEmployee = employeeData.find((employee) => {
        const employeeEmail = String(employee.Email || '').trim().toLowerCase();
        const employeeName = String(employee.EmployeeName || '').trim().toLowerCase();
        return (normalizedEmail && employeeEmail === normalizedEmail)
          || (normalizedName && employeeName === normalizedName);
      });

      if (matchedEmployee?.EmployeeName) {
        setSelectedEmployee(matchedEmployee.EmployeeName);
        return;
      }

      setSelectedEmployee('');
    }, [employeeData, user?.email, user?.name]);

    useEffect(() => {
      if (!user?.email) {
        return;
      }

      setUserPreferences(user.email, {
        reportsAssignedEmployee: selectedEmployee || '',
      });
    }, [selectedEmployee, user?.email]);

    useEffect(() => {
      const normalizedEmail = String(user?.email || '').trim().toLowerCase();
      if (!normalizedEmail) {
        setTogglePreferencesLoadedFor('');
        return;
      }

      const preferences = getUserPreferences(normalizedEmail);
      setShowCompleted(typeof preferences.reportsShowCompleted === 'boolean' ? preferences.reportsShowCompleted : true);
      setShowLate(typeof preferences.reportsShowLate === 'boolean' ? preferences.reportsShowLate : false);
      setTogglePreferencesLoadedFor(normalizedEmail);
    }, [user?.email]);

    useEffect(() => {
      const normalizedEmail = String(user?.email || '').trim().toLowerCase();
      if (!normalizedEmail || togglePreferencesLoadedFor !== normalizedEmail) {
        return;
      }

      setUserPreferences(normalizedEmail, {
        reportsShowCompleted: showCompleted,
        reportsShowLate: showLate,
      });
    }, [showCompleted, showLate, togglePreferencesLoadedFor, user?.email]);


    useEffect(() => {
      const today = new Date().toISOString().split('T')[0];
      const filteredData = actionData.filter(item => {
        const isCompleted = item.CompletedDate != null;
        const isLate = item.DueDate < today && !isCompleted;
        const isAssignedToSelectedEmployee = selectedEmployee ? item.AssignedEmployeeName === selectedEmployee : true;
    
        return (showCompleted || !isCompleted) &&
               (showLate ? isLate : true) &&
               isAssignedToSelectedEmployee;
      });
    
      setFilteredActionData(filteredData);
    }, [actionData, showCompleted, showLate, selectedEmployee]);
    
  
  //for green color switch
  const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: green[600],
      '&:hover': {
        backgroundColor: alpha(green[600], theme.palette.action.hoverOpacity),
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: green[600],
    },
  }));
    //for red color switch
    const RedSwitch = styled(Switch)(({ theme }) => ({
      '& .MuiSwitch-switchBase.Mui-checked': {
        color: red[600],
        '&:hover': {
          backgroundColor: alpha(red[600], theme.palette.action.hoverOpacity),
        },
      },
      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: red[600],
      },
    }));

  return (
    <>
          {/* ---------------------TABLE  --------------------------------   
      -------------------------TABLE  --------------------------------  
      -------------------------TABLE  --------------------------------     */}   
<aside className={`${styles.database} ${styles[theme]}`}>
<Box className={`  ${styles[theme]}`} sx={{display: 'flex',flexDirection: 'row',width: '100%'}}>
               {/* BOX1 */}
              <Box className={` ${styles[theme]}`} sx={{m:1,width:'100%'}}>
                <Paper elevation={1}> 
                
                <Box className={`${styles.box} ${styles[theme]}`}
                    sx={{
                      display: 'flex', // Use flex display
                      justifyContent: 'space-between', // Center the content horizontally
                      alignItems: 'center', // Align items vertically in the center
                      paddingTop: '8px', // Optional padding at the top
                      paddingBottom: '8px', // Optional padding at the bottom
                    }}
                  >
                    

                    {/* Typography for "Actions" text */}
                    <Box sx={{
                      display: 'flex',
                       }}>
                    <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'left',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                        paddingLeft: '10px'
                      }}
                      variant="h6"
                      gutterBottom
                    >
                     All Actions
                    </Typography>
                    <Typography 
                      sx={{
                        paddingLeft: '20px',
                        paddingTop: '2px',
                        textAlign: 'left',
                      }}
                      variant="overline"
                      
                    >
                     <u>Report</u>
                    </Typography>
                    </Box>
                    <Box sx={{
                      display: 'flex',
                       }}>
                    <FormControl sx={{width:'250px', paddingRight:'270px', paddingTop:'5px'}}>
                      <InputLabel className={`${styles.select} ${styles[theme]}`} id="employee-select-label">Filter By Employee Assigned</InputLabel>
                      <Select className={`${styles.select} ${styles[theme]}`}
                        style={{ height: '45px' }}
                        labelId="employee-select-label"
                        value={selectedEmployee}
                        onChange={(event) => setSelectedEmployee(event.target.value)}
                        //displayEmpty
                        renderValue={selectedEmployee !== '' ? undefined : () => <em>None</em>}
                      >
                        <MenuItem value="">
                          <em>None</em>
                        </MenuItem>
                        {employeeData.map((employee) => (
                          <MenuItem key={employee.EmployeeID} value={employee.EmployeeName}>{employee.EmployeeName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControlLabel 
                          control={
                            <RedSwitch 
                              checked={showLate}
                              onChange={(event) => setShowLate(event.target.checked)} 
                              
                            />
                          } 
                          label="Show Only Late Actions" 
                        />
                    <FormControlLabel 
                          control={
                            <GreenSwitch 
                              checked={showCompleted}
                              onChange={(event) => setShowCompleted(event.target.checked)} 
                              
                            />
                          } 
                          label="Show Completed Actions" 
                        />
                         </Box>
                     {/* IconButton wrapping the IoMdAddCircle icon */}
                    {/* <Button onClick={handleClickOpen} aria-label="add">
                      <MdOutlineLibraryAdd style={{ fontSize: '30px', float: 'right' }} />
                    </Button> */}
                    
                   


                 


                  </Box>
               
                </Paper> 
                
                
                

                  {/* TABLE DATA* */}
                  {/* TABLE DATA*/}
                  {/* TABLE DATA**/}


                  <style>
                    {`
                      .light-theme .my-datagrid .MuiDataGrid-root .MuiDataGrid-cell,
                      .light-theme .my-datagrid .MuiDataGrid-root .MuiDataGrid-columnHeader {
                        background-color: #f0f0f0; /* Light theme background color */
                        color: #000000; /* Light theme text color */
                        font-weight: bold; /* Makes the font bold */
                      }
                  
                      .light-theme .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }
                      /* Dark theme styles */
                      .dark-theme .MuiDataGrid-root {
                        border-color: #2c2c2b; /* Dark theme border color */
                      }
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaders,
                      .dark-theme .my-datagrid .MuiDataGrid-cell,
                      .dark-theme .my-datagrid .MuiTablePagination-root,
                      .dark-theme .my-datagrid .MuiDataGrid-withBorderColor,
                      .dark-theme .my-datagrid .MuiDataGrid-root,
                      .dark-theme .MuiTypography-root,
                      .dark-theme .MuiButtonBase-root.MuiIconButton-root,
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaderTitle {
                        background-color: ##000; /* Dark theme background color */
                        color: #D8D8D8; /* Dark theme text color */
                        border-color: #2c2c2b;
                         /* Makes the font bold */
                      }
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiTablePagination-caption,
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiTablePagination-toolbar,
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiIconButton-label,
                      .dark-theme .my-datagrid .MuiButtonBase-root.MuiIconButton-root.Mui-disabled
                      {
                        color: #ffffff; /* Dark theme pagination text color */
                       
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }

                   
                  
                      
                      
                      
                    `}
                    </style>

                <TableContainer  className={`${styles[theme]} ${theme === 'light' ? 'light-theme' : 'dark-theme'}`}  style={{ height: '87vh', overflowY: 'auto' }}  >
                {/* <div style={{ height: '85vh', width: '100%' }}> */}
                  <DataGrid
                  className="my-datagrid"
                    rows={filteredActionData}
                    columns={columns}
                    initialState={{
                      pagination: {
                        paginationModel: { page: 0, pageSize: 13 },
                      },
                    }}
                    pageSizeOptions={[5, 10]}
                    //checkboxSelection
                  />
                </TableContainer>

                <Dialog
                  className={`${styles[theme]}`}
                  PaperProps={{
                    className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                  }}
                  open={isEditDialogOpen}
                  onClose={() => setIsEditDialogOpen(false)}
                  maxWidth="md"
                  fullWidth
                >
                  <DialogTitle>EDIT ACTION</DialogTitle>
                  <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mt: 1, flexWrap: 'wrap' }}>
                      <TextField
                        InputProps={{
                          readOnly: true,
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        }}
                        helperText="Location cannot be changed."
                        label="LOCATION"
                        color="success"
                        focused
                        value={editFormData.locationName}
                        sx={{ width: '300px' }}
                      />
                      <TextField
                        InputProps={{
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          },
                        }}
                        id="sortOrder"
                        label="Sort Order"
                        type="number"
                        variant="outlined"
                        value={editFormData.sortOrder}
                        onChange={(e) => handleChangeEditAction('sortOrder', e.target.value)}
                        sx={{ width: '150px' }}
                      />
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                      <TextField
                        InputProps={{
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                          },
                        }}
                        autoFocus
                        margin="dense"
                        id="action-name"
                        label="Action Name"
                        type="text"
                        variant="outlined"
                        value={editFormData.actionName || ''}
                        onChange={(e) => handleChangeEditAction('actionName', e)}
                        sx={{ width: '300px' }}
                      />

                      <FormControl margin="dense" sx={{ width: '220px' }}>
                        <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="action-type-label">Action Type</InputLabel>
                        <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                          labelId="action-type-label"
                          id="action-type-select"
                          value={editFormData.actionType}
                          label="Action Type"
                          onChange={(e) => handleChangeEditAction('actionType', e.target.value)}
                        >
                          {actionTypeData.map((type) => (
                            <MenuItem key={type.ActionTypeID} value={type.ActionTypeID}>
                              {type.ActionTypeName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <FormControl margin="dense" sx={{ width: '260px' }}>
                        <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="employee-label">Assign SiCam Employee</InputLabel>
                        <Select
                          className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                          labelId="employee-label"
                          id="employee-select"
                          value={editFormData.actionEmployee}
                          label="Assign SiCam Employee"
                          onChange={(e) => handleChangeEditAction('actionEmployee', e.target.value)}
                        >
                          {employeeData.map((employee) => (
                            <MenuItem key={employee.EmployeeID} value={employee.EmployeeID}>
                              {employee.EmployeeName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, mt: 1, flexWrap: 'wrap' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Due Date"
                          value={editFormData.dueDate}
                          onChange={(newValue) => handleChangeEditAction('dueDate', newValue)}
                          sx={{
                            width: '220px',
                            '& .MuiInputLabel-root': {
                              color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                            },
                            '& .MuiInputBase-input': {
                              color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                            },
                            '& .MuiIconButton-root': {
                              color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                            },
                          }}
                        />
                      </LocalizationProvider>

                      {editFormData.completedDate && (
                        <FormControl margin="dense" sx={{ width: '260px' }}>
                          <InputLabel className={theme === 'light' ? styles.lightLabel : styles.darkLabel} id="completed-employee-label">Completed By</InputLabel>
                          <Select
                            className={theme === 'light' ? styles.lightSelect : styles.darkSelect}
                            labelId="completed-employee-label"
                            id="completed-employee-select"
                            value={editFormData.completedEmployee}
                            label="Completed By"
                            onChange={(e) => handleChangeEditAction('completedEmployee', e.target.value)}
                          >
                            {employeeData.map((employee) => (
                              <MenuItem key={employee.EmployeeID} value={employee.EmployeeID}>
                                {employee.EmployeeName}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {editFormData.completedDate && (
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Completed Date"
                            value={editFormData.completedDate}
                            onChange={(newValue) => handleChangeEditAction('completedDate', newValue)}
                            sx={{
                              width: '220px',
                              '& .MuiInputLabel-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(140, 148, 156, 0.986)',
                              },
                              '& .MuiInputBase-input': {
                                color: theme === 'light' ? '#000000' : 'rgb(247, 247, 247)',
                              },
                              '& .MuiIconButton-root': {
                                color: theme === 'light' ? '#000000' : 'rgba(176, 185, 193, 0.98)',
                              },
                            }}
                          />
                        </LocalizationProvider>
                      )}
                    </Box>
                  </DialogContent>
                  <DialogActions sx={{ marginRight: '20px' }}>
                    <Button variant="contained" color="error" onClick={() => setIsEditDialogOpen(false)}>Cancel</Button>
                    <Button variant="contained" color="success" onClick={handleEditActionSave}>Save</Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  className={`${styles[theme]}`}
                  PaperProps={{
                    className: theme === 'light' ? styles['light-dialogPaper'] : styles['dark-dialogPaper'],
                  }}
                  open={isDeleteDialogOpen}
                  onClose={() => setIsDeleteDialogOpen(false)}
                  maxWidth="xs"
                  fullWidth
                >
                  <DialogTitle>DELETE ACTION</DialogTitle>
                  <DialogContent>
                    <Typography
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'center',
                        mt: 2,
                      }}
                      variant="h6"
                      gutterBottom
                    >
                      Are you sure?
                    </Typography>
                    {deleteAction.ActionName ? (
                      <Typography sx={{ textAlign: 'center' }} variant="body2">
                        {deleteAction.ActionName}
                      </Typography>
                    ) : null}
                  </DialogContent>
                  <DialogActions sx={{ marginRight: '20px' }}>
                    <Button variant="contained" color="error" onClick={() => setIsDeleteDialogOpen(false)}>Cancel</Button>
                    <Button variant="contained" color="success" onClick={handleDeleteActionSave}>Yes</Button>
                  </DialogActions>
                </Dialog>
              </Box>
            </Box> 
            </aside>
    </>
    
  )
}

export default Reports
